<div *ngIf="DebugRecordsGridData.length > 0">
	<div class="panel panel-default">
		<div class="panel-heading">
			<h4 class="panel-title">PolarLink Debug Records</h4>
		</div>
		<div class="panel-body">
			<app-grid-v2 #debugRecordsGrid
				translateHeaders="true"
				id="PlinkDebugRecordsGrid"
				[modelId]="device.deviceid"
				[columns]="DebugRecordsGridColumns"
				[data]="DebugRecordsGridData"
				[settings]="settings"
				(onCellClicked)="onDebugRecordCellClicked($event)"
			></app-grid-v2>
		</div>
	</div>
</div>

<div *ngIf="DebugRecordsGridData.length == 0">
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No PolarLink Debug Records Found in Selected Period!</strong>
		</div>
	</div>
</div>
